import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";
import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

async function getCategory() {
  const data = await axiosInstance({
    url: "/category",
    method: "GET",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function createCategory(formData) {
  const data = await axiosInstance({
    url: "/category",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function updateCategory(formData) {
  const data = await axiosInstance({
    url: `/category/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function deleteCategory(formData) {
  const data = await axiosInstance({
    url: `/category/${formData}`,
    method: "DELETE",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useCategory() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.category],
    queryFn: getCategory,
  });
  return data;
}

export function useAddCategory() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => createCategory(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.category]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
export function useDeleteCategory() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => deleteCategory(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.category]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useUpdateCategory() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => updateCategory(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.category]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
